import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { astriskStyle } from 'src/styles/CommonStyles.styled';
import { SECONDARY_FONT_COLOR, FONT_FAMILY_REGULAR, SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

export const RadioRowDiv = styled.div`
    display: inline-flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const Title = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    color:${SECONDARY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    margin-bottom: 8px;
    ${astriskStyle};
`;

export const PhysicianTerritoryStyle = styled.div`
    width: 96%;
    height: 108px;
    opacity: 1;
    margin-bottom: ${({ showProcedureDropdown }) =>
        showProcedureDropdown ? '0px' : '20px'};
    ${media.smalDevice` 
        width: 100%;
        margin-bottom:25px;
    `}
    ${media.mobileDevice` 
        width: 100%;
       margin-bottom:  ${({ showProcedureDropdown }) =>
           showProcedureDropdown ? '25px' : '5px'};
    `}
`;
